import { createSlice } from "@reduxjs/toolkit";
import {
  getDocumentsDataThunk,
  getDocumentsData,
  getWebContentsData,
} from "./eventOrganiserThunks";

const initialState = {
  loading: false,
  error: null,
  documentList: [],
  isOrgAccess: 3,
  roleData: JSON.parse(localStorage.getItem("roleData")) || [],
  webContents: [],
};

const eventOrganiserSlice = createSlice({
  name: "eventOrganiser",
  initialState,
  reducers: {
    toggleForm: (state, action) => {
      state.showForm = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDocumentsDataThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDocumentsDataThunk.fulfilled, (state, action) => {
        state.documentList = action.payload;
      })
      .addCase(getDocumentsDataThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to update users";
      })
      .addCase(getDocumentsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDocumentsData.fulfilled, (state, action) => {
        state.loading = false;
        state.documentList = action.payload;
      })
      .addCase(getDocumentsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getWebContentsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getWebContentsData.fulfilled, (state, action) => {
        state.loading = false;
        state.webContents = action.payload;
      })
      .addCase(getWebContentsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const {
  setSelectedEvent,
  clearSelectedEvent,
  setSelectedActivity,
  setIsNewCostSheet,
  clearSelectedActivity,
  setCostSheet,
  updateFormData,
  addActivity,
  removeActivity,
  updateActivity,
  resetFormData,
  toggleForm,
} = eventOrganiserSlice.actions;
export default eventOrganiserSlice.reducer;
